import { LingerContextSchemaData } from 'lib/analytics'
import { useEffect, useRef } from 'react'
import { useInView } from 'react-intersection-observer'

type Props = {
  threshole?: number
  enterCallback?: (params: LingerContextSchemaData) => void
  leaveCallback?: (params: LingerContextSchemaData) => void
  skip?: boolean
}

export const useLinger = ({
  threshole = 1000,
  enterCallback,
  leaveCallback,
  skip,
}: Props) => {
  const firstImpression = useRef(true)
  const visibilityStart = useRef(0)

  const { ref: inViewRef, inView } = useInView({ skip })

  const checkLinger = () => {
    if (!visibilityStart.current || skip) return

    const now = Date.now()
    if (now - visibilityStart.current < threshole) return

    leaveCallback?.({
      first_impression: firstImpression.current,
      visibility_start: visibilityStart.current.toString(),
      visibility_end: now.toString(),
    })

    if (firstImpression) firstImpression.current = false
    visibilityStart.current = 0
  }

  useEffect(() => {
    if (skip) return

    if (inView) {
      visibilityStart.current = Date.now()
      enterCallback?.({
        first_impression: firstImpression.current,
        visibility_start: visibilityStart.current.toString(),
        visibility_end: '',
      })
    } else {
      checkLinger()
    }
  }, [skip, inView])

  useEffect(() => {
    return () => {
      checkLinger()
    }
  }, [])

  return {
    inViewRef,
  }
}
